import { propTypes, withFormsy } from 'formsy-react';
import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

class DGRadioGroup extends Component {


    componentDidMount() {

    }

    childUpdated = (childValue) => {
        this.props.setValue(childValue);

    }

    changeValue = (event) => {

        this.props.setValue(event.currentTarget.value);

    }
    componentDidMount(){

        let value = null;
        const fields = this.props.fields;
        fields.map((field, fieldIndex) => {
            if(field.value === 'checked'){
                value = (field.fieldID);
            }
        });
        //const values=[1,2];
        
        this.props.setValue(value);
        

    }
    render() {

        const fields = this.props.fields;

        const childrenWithProps = React.Children.map(this.props.children, child => {
            // checking isValidElement is the safe way and avoids a typescript error too
            const props = { ...{ name: this.props.name, radio: true, childUpdated: this.childUpdated } };
            if (React.isValidElement(child)) {
                return React.cloneElement(child, props);
            }

            return child;
        });

        return (
            <>
                {/*<div className="ui grid">
                    {childrenWithProps.map(child => {
                        return <div className="eight wide column">{child}</div>
                    })}
                </div>*/}
                <Grid>
                    {
                        fields && fields.map((field, fieldIndex) => {
                            return <Grid.Column computer={8} mobile={16} tablet={8} key={`radiogroup-grid-column-${field.fieldID}`}>
                                <div className={`chkbox-field ${!this.props.isPristine && !this.props.isValid ? 'error' : ''}`} key={`chkbox-field-${field.fieldID}`}>
                                    <label className="checkbox" key={`chkbox-${field.fieldID}`} >

                                        <input type="radio" name={this.props.name} key={`chkbox-ctrl-${field.fieldID}`} onChange={this.changeValue} value={field.fieldID} checked={this.props.value == field.fieldID} />


                                        <span className="checkbox__icon" key={`chkbox-icon-${field.fieldID}`}></span>
                                        <span className="text" key={`chkbox-label-${field.fieldID}`}>{field.name}</span>
                                    </label>
                                </div>
                            </Grid.Column>
                        })
                    }
                </Grid>

                {
                    !this.props.isPristine && !this.props.isValid &&
                    <div className="error" key={`chkbox-error-${this.props.name}`}>
                        {this.props.errorMessage}
                    </div>
                }
            </>
        );
    }
}

DGRadioGroup.propTypes = {
    ...propTypes
}

export default withFormsy(DGRadioGroup)